import React from "react";
import { connect } from "react-redux";
import CallMenu from "./CallMenu";
import ViewPatientProfile from "../patient/profile_viewer/ViewPatientProfile";
import { openPanel } from "../../Redux/Panels/RightPanel/actions";
import { ACCESS_PERMISSIONS, APPS_NAME } from "../../Constants/main";

const CallTools = ({ isDoctor, openPanel, meeting }) => {

    const openPatientProfile = (type) => {
        openPanel({
          title: `Profile: ${meeting?.patient_info?.name}`,
          content: ViewPatientProfile({
            id: meeting?.patient_info?.id,
            patient: meeting?.patient_info,
            type,
            callback: () => {},
          }),
          customClassName: "view-patient-profile",
        });
      };

    const leaveDoctorReview = () => {};

    const leavePatientReview = () => {};

    const handleEndCall = () => {};

	const patientMenu = [
		{
			name: "Doctor Profile",
			icon: "user-md",
			onClick: () => {
				console.log("Call");
			},
            show: false,
		},
		{
			name: "Review Doctor",
			icon: "comment-dots",
			onClick: () => leaveDoctorReview(),
            show: false,
		},
	];

	const doctorMenu = [
		{
			name: "Medical Profile",
			icon: "clipboard-list",
			onClick: () => openPatientProfile(APPS_NAME.MEDICAL_PROFILE),
            show: ACCESS_PERMISSIONS.includes(APPS_NAME.MEDICAL_PROFILE),
		},
		{
			name: "Prescription",
			icon: "briefcase-medical",
			onClick: () => openPatientProfile(APPS_NAME.PRESCRIPTION),
            show: ACCESS_PERMISSIONS.includes(APPS_NAME.PRESCRIPTION),
		},
		{
			name: "Recommendations",
			icon: "clinic-medical",
			onClick: () => openPatientProfile(APPS_NAME.RECOMMENDATIONS),
            show: ACCESS_PERMISSIONS.includes(APPS_NAME.RECOMMENDATIONS),
		},
        {
			name: "Review Patient",
			icon: "comment-dots",
			onClick: () => leavePatientReview(),
            show: false,
		},
	];

	return <CallMenu menu={(isDoctor ? doctorMenu : patientMenu).filter(({ show }) => show).reverse()} />;
};

const mapStateToProps = ({ user }) => {
	return { user: user.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
        openPanel: (e) => dispatch(openPanel(e)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallTools);
